import { useState } from "react";
import Navbar from "../components/Navbar";
import ConfigFormComponent from "../components/config_components/ConfigFormComponent";
import InstrumentBlock from "../components/config_components/InstrumentBlock";
import SensorBlock from "../components/config_components/SensorBlock";
import ParamsBlock from "../components/config_components/ParamsBlock";
import PageContainer from "../components/containers/PageContainer";
import ConfigContainer from "../components/config_components/ConfigContainer";
import SubmitButton from "../components/form_components/FormButton";
import Button from "../components/Button";
import Input from "../components/form_components/Input";

export default function ConfigForm() {

    type FormObject = {
        'name': string,
        'type': string,
        'db_field': string,
        'required': boolean
    };

    const InstrumentArray: FormObject[] = [
        { name: 'ID', type: 'input', db_field: 'instrument_id', required: true },
        { name: 'Name', type: 'input', db_field: 'instrument_name', required: true },
        { name: 'Address', type: 'number', db_field: 'instrument_address', required: true },
        { name: 'Parser', type: 'select', db_field: 'instrument_parser', required: true }, // DROPDOWN: nmae_parser, sbe_parser
        { name: 'Priority', type: 'number', db_field: 'instrument_priority', required: true },
    ]

    const SensorArray: FormObject[] = [
        { name: 'ID', type: 'text', db_field: 'sensor_id', required: true },
        { name: 'Frequency', type: 'number', db_field: 'sensor_name', required: true },
    ]

    const ParamsArray: FormObject[] = [
        { name: 'ID', type: 'number', db_field: 'params_id', required: true },
        { name: 'Transform', type: 'input', db_field: 'params_transform', required: true },
        { name: 'Mode', type: 'select', db_field: 'params_mode', required: true }, // DROPDOWN: Sample, Average, Median, Maximal, Minimal
        { name: 'Decimals', type: 'number', db_field: 'params_decimals', required: true },
        { name: 'Alias', type: 'input', db_field: 'params_alias', required: true },
        { name: 'Column', type: 'input', db_field: 'params_column', required: true },
        { name: 'Graph', type: 'checkbox', db_field: 'params_graph', required: true }, // Checkbox
        { name: 'p06', type: 'vocab', db_field: 'params_p06', required: true },
    ]

    return (
        <>
            <Navbar />
            <PageContainer title="Config Form">
                <ConfigFormComponent post="">
                    <ConfigContainer title="Instrument">
                        {InstrumentArray.map((sensor) => (
                            <Input width="" label={sensor.name} type={sensor.type} placeholder={sensor.name} extraClasses='border rounded px-2' required={true} onChange={(name, value) => { }} name={sensor.db_field} />
                        ))}
                        <ConfigContainer title="Sensor">
                        {SensorArray.map((sensor) => (
                            <Input width="" label={sensor.name} type={sensor.type} placeholder={sensor.name} extraClasses='border rounded px-2' required={true} onChange={(name, value) => { }} name={sensor.db_field} />
                        ))}
                            <ConfigContainer title="Parameters">
                            {ParamsArray.map((sensor) => (
                                <Input width="" label={sensor.name} type={sensor.type} placeholder={sensor.name} extraClasses='border rounded px-2' required={true} onChange={(name, value) => { }} name={sensor.db_field} />
                            ))}
                            </ConfigContainer>
                        </ConfigContainer>
                    </ConfigContainer>
                    
                    <Button width="" label="Submit" />
                </ConfigFormComponent>
            </PageContainer>
        </>
    )
}